import React, { Component } from 'react';
var Api = require('./Config');

export default class AdminDoctor extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setState({ COUNT: 0 });
  }

  componentDidMount() {
    Api.getAlertForDoctor()
      .then((alert) => {
        this.setState({ COUNT: alert.COUNT });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div>
        <div className="jumbotron">
          <h1>Welcome</h1>
          <p>You have {this.state.COUNT} patients with warnings</p>
          <p>
            <a
              className="btn btn-lg btn-primary"
              onClick={() => {
                this.props.history.push('/alerts');
              }}
              role="button"
            >
              View &raquo;
            </a>
          </p>
        </div>
      </div>
    );
  }
}
